// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-preview {
  display: grid !important;
  grid-template-columns: 1fr minmax(auto, 32px);
  align-items: center;
  grid-gap: 0.25rem;
  gap: 0.25rem;
  border: 1px solid var(--primary-color-light-200);
  border-radius: 8px;
  background: var(--primary-color-light-200);
  border-radius: 10px;
  transition: all 0.2s ease;
  min-height: 40px;
  border: 0;
}
.link-preview::before, .link-preview::after {
  content: "";
  display: none;
}
.link-preview:hover {
  border: 1px solid var(--primary-color-dark-300);
  border-radius: 8px;
  background: var(--primary-color-light-500);
  border: 0;
}
.link-preview__content {
  display: grid;
  align-items: center;
  cursor: pointer;
  min-width: 0;
  overflow: hidden;
  border: 0;
  padding: 0.25rem 0 0.25rem 0.5rem;
  height: 100%;
  color: var(--accent-color-1);
}
.link-preview__content:hover, .link-preview__content:active, .link-preview__content:focus {
  border: 0;
}
.link-preview__title {
  display: block !important;
  font-weight: 500;
  font-size: 0.875rem;
  color: var(--accent-color-1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 10px);
}
.link-preview__url {
  font-size: 0.75rem;
  color: var(--color-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.8;
}
.link-preview__copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 32px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  padding: 0;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--color-text-secondary);
}
.link-preview__copy-btn:hover {
  background: var(--color-background-medium);
  color: var(--color-text-primary);
}
.link-preview__copy-btn--copied {
  color: var(--color-success);
}
.link-preview__copy-btn--copied:hover {
  color: var(--color-success);
}
.link-preview__copy-btn .material-icons {
  font-size: 18px;
}
@media screen and (max-width: 768px) {
  .link-preview {
    gap: 0.5rem;
  }
  .link-preview__title {
    max-width: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Commons/LinkPreview/LinkPreview.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,6CAAA;EACA,mBAAA;EACA,iBAAA;EAAA,YAAA;EACA,gDAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;AACJ;AAEE;EACE,+CAAA;EACA,kBAAA;EACA,0CAAA;EACA,SAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,iCAAA;EACA,YAAA;EACA,4BAAA;AADJ;AAGI;EACE,SAAA;AADN;AAKE;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;AAHJ;AAME;EACE,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,kCAAA;AALJ;AAOI;EACE,0CAAA;EACA,gCAAA;AALN;AAQI;EACE,2BAAA;AANN;AAQM;EACE,2BAAA;AANR;AAUI;EACE,eAAA;AARN;AAYE;EA9FF;IA+FI,WAAA;EATF;EAWE;IACE,gBAAA;EATJ;AACF","sourcesContent":[".link-preview {\n  display: grid !important;\n  grid-template-columns: 1fr minmax(auto, 32px);\n  align-items: center;\n  gap: 0.25rem;\n  border: 1px solid var(--primary-color-light-200);\n  border-radius: 8px;\n  background: var(--primary-color-light-200);\n  border-radius: 10px;\n  transition: all 0.2s ease;\n  min-height: 40px;\n  border: 0;\n\n  &::before, &::after {\n    content: \"\";\n    display: none;\n  }\n  \n  &:hover {\n    border: 1px solid var(--primary-color-dark-300);\n    border-radius: 8px;\n    background: var(--primary-color-light-500);\n    border: 0;\n  }\n\n  &__content {\n    display: grid;\n    align-items: center;\n    cursor: pointer;\n    min-width: 0;\n    overflow: hidden;\n    border: 0;\n    padding: 0.25rem 0 0.25rem 0.5rem;\n    height: 100%;\n    color: var(--accent-color-1);\n\n    &:hover, &:active, &:focus {\n      border: 0;\n    }\n  }\n\n  &__title {\n    display: block !important;\n    font-weight: 500;\n    font-size: 0.875rem;\n    color: var(--accent-color-1);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: calc(100% - 10px);\n  }\n\n  &__url {\n    font-size: 0.75rem;\n    color: var(--color-text-secondary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    opacity: 0.8;\n  }\n\n  &__copy-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 32px;\n    width: 32px;\n    height: 32px;\n    border: none;\n    border-radius: 6px;\n    padding: 0;\n    background: transparent;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: var(--color-text-secondary);\n\n    &:hover {\n      background: var(--color-background-medium);\n      color: var(--color-text-primary);\n    }\n\n    &--copied {\n      color: var(--color-success);\n      \n      &:hover {\n        color: var(--color-success);\n      }\n    }\n\n    .material-icons {\n      font-size: 18px;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    gap: 0.5rem;\n    \n    &__title {\n      max-width: 150px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
